import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { EvalinfRegfurComponent } from '../evalinf-regfur/evalinf-regfur.component';
import { FormularioWebComponent } from '../formulario-web/formulario-web.component';
import { FurService } from 'src/app/services/fur.service';

@Component({
  selector: 'app-fur',
  templateUrl: './fur.component.html',
  styleUrls: ['./fur.component.css']
})
export class FurComponent implements OnInit, AfterViewInit {


  @ViewChild(EvalinfRegfurComponent) hojaEvaluacionCmp: EvalinfRegfurComponent;

  constructor(private serviceFur: FurService) { }

  ngOnInit() {
  }

  ngAfterViewInit(): void {

//   this.hojaEvaluacionCmp.formularioCmp.denunciaContenedorC.entidadHechoC.modoLectura(true);
  }

}
